module.exports = __webpack_public_path__ + "img/img15.413adbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/01/img15.png
// module id = 170
// module chunks = 0